// extracted by mini-css-extract-plugin
export default {"errorOuter":"error_errorOuter__EzulW","imageContainer":"error_imageContainer__ocoHo","pinImage":"error_pinImage__cC0I1","buttonContainer":"error_buttonContainer__VqHxZ"};